import { render, staticRenderFns } from "./UpsellWidget.vue?vue&type=template&id=cb065dca&"
import script from "./UpsellWidget.vue?vue&type=script&lang=js&"
export * from "./UpsellWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports